import { Alert, Typography } from '@mui/material'
import styled from 'styled-components/macro'
import { RenderElementProps } from 'slate-react'
import CSS from 'csstype'

import { Block } from './plugins/withBlocks'
import { EmbedView } from './plugins/withEmbeds'

const UnorderedList = styled.ul`
    padding-left: ${({ theme }) => theme.spacing(3)};
    margin: 0px;
`
const OrderedList = styled.ol`
    padding-left: ${({ theme }) => theme.spacing(3)};
    margin: 0px;
`

const Header = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(2)} !important;
    border-bottom: 1px solid #ccc;
`

export function ElementComponent(props: RenderElementProps) {
    const { element, attributes, children } = props
    const style: CSS.Properties = {}

    if (Block.isBlock(element) && element.alignment) {
        style.textAlign = element.alignment
    }

    switch (element.type) {
        case 'paragraph':
            return (
                <Typography style={style} variant="body1" {...attributes}>
                    {children}
                </Typography>
            )
        case 'h1':
        case 'h2':
            return (
                <Header style={style} variant={element.type} {...attributes}>
                    {children}
                </Header>
            )
        case 'h3':
        case 'h4':
        case 'h5':
            return (
                <Typography style={style} variant={element.type} {...attributes}>
                    {children}
                </Typography>
            )
        case 'ul':
            return <UnorderedList {...attributes}>{children}</UnorderedList>
        case 'ol':
            return <OrderedList {...attributes}>{children}</OrderedList>
        case 'li':
            return <li {...attributes}>{children}</li>
        case 'link':
            return (
                // eslint-disable-next-line react/jsx-no-target-blank
                <a href={element.url} target="_blank" {...attributes}>
                    {children}
                </a>
            )
        case 'alert':
            return (
                <Alert severity={element.severity} {...attributes}>
                    {children}
                </Alert>
            )
        case 'embed':
            return <EmbedView {...props} element={element} />
        default:
            return <span {...attributes}>{children}</span>
    }
}
